<template>
  <BaseModal modalColor="border-warning bg-warning" iconModal="fa fa-warning" subtitulo="Editar dado"
             col-md="col-md-3" offset="offset-3">
    <template v-slot:modalContent>
      <form ref="editarForm" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="descricao" v-model="dado.descricao" size="small" style="width: 100%"
                           :invalid="campoVazio.includes('descricao')" autofocus/>
                <label for="descricao"><strong>descricao: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="estoque" v-model="dado.estoque" size="small" style="width: 100%"
                             fluid :inputStyle="{ textAlign: 'right' }" :invalid="campoVazio.includes('estoque')"/>
                <label for="estoque"><strong>Estoque: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="ultimo_valor" v-model="dado.ultimo_valor" size="small" style="width: 100%"
                             fluid :inputStyle="{ textAlign: 'right' }" disabled/>
                <label for="ultimo_valor"><strong>Último Valor: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.status"
                    inputId="status"
                    :options="status"
                    optionLabel="label"
                    optionValue="value"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                    :invalid="campoVazio.includes('status')"
                />
                <label for="status">
                  <strong>Status: <span class="text-danger font-bold">*</span></strong>
                </label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fechar')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "EditarMaterial",
  components: {
    BaseModal,
  },
  props: {
    itemKey: String,
  },
  data() {
    return {
      dado: 1,
      erro: null,
      campoVazio: [],
      status: [
        {label: 'ATIVO', value: 'A'},
        {label: 'INATIVO', value: 'I'}
      ],
    }
  },
  emits: ["fechar", "atualizarDados"],
  methods: {
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.materiais.retrieveUpdateDestroy(this.itemKey)}?modo=edit`);
      if (resultado.success) {
        this.dado = resultado.data;
      } else {
        alertMessage("warning", "Atenção", "Erro ao carregar registro!");
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitEditForm() {
      const resultado = await apiRequest("PATCH", apiUrl.materiais.retrieveUpdateDestroy(this.itemKey), this.dado);
      if (resultado.success) {
        this.$emit("atualizarDados", resultado.data);
        this.$toastMessage("success", "Registro alterado com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getDados();
  },
}
</script>
